// Global object for YouTube players.
var youtubePlayers = {};

// YouTube IFrame API Ready callback – initialize players for all YouTube iframes.
window.onYouTubeIframeAPIReady = function() {
  document.querySelectorAll('.youtube-iframe').forEach(function(iframe, index) {
    if (!iframe.id) {
      iframe.id = "youtube-player-" + index;
    }
    youtubePlayers[iframe.id] = new YT.Player(iframe.id);
  });
};

// Wait for the container ".bad-owl-tool-container" to exist before initialization.
function waitForBadOwlContainer() {
  if (document.querySelector('.bad-owl-tool-container')) {
    initializeBadOwlTool();
    setupAccordionDelegation();
  } else {
    setTimeout(waitForBadOwlContainer, 100);
  }
}

document.addEventListener("DOMContentLoaded", waitForBadOwlContainer);

if (window.Shopify && Shopify.designMode) {
  // Delay to ensure sections are fully loaded.
  document.addEventListener("shopify:section:load", function() {
    setTimeout(waitForBadOwlContainer, 200);
  });
  document.addEventListener("shopify:section:select", function() {
    setTimeout(waitForBadOwlContainer, 200);
  });
}

function initializeBadOwlTool() {
  // Wait until the accordion container exists.
  if (!document.querySelector(".accordion")) {
    setTimeout(initializeBadOwlTool, 200);
    return;
  }
  
  // Initialize swipers for all matching elements.
  document.querySelectorAll("[class*='swiper-main-cat-']").forEach(function(mainEl) {
    initializeMainSwiper(mainEl);
  });
}

function initializeMainSwiper(mainEl) {
  if (mainEl.querySelectorAll('.swiper-slide').length === 1) {
    mainEl.classList.add('single-video');
  } else {
    mainEl.classList.add('multiple-videos');
  }
  
  var swiperInstance = new Swiper(mainEl, {
    effect: 'coverflow',
    coverflowEffect: {
      rotate: 30,
      stretch: 0,
      depth: 200,
      modifier: 1,
      slideShadows: true
    },
    // Disable drag/touch features to avoid interfering with the accordion.
    grabCursor: false,
    simulateTouch: false,
    allowTouchMove: false,
    centeredSlides: true,
    loop: true,
    spaceBetween: 10,
    slidesPerView: 1,
    breakpoints: {
      320: { slidesPerView: 1, spaceBetween: 10 },
      768: { slidesPerView: 1, spaceBetween: 20 },
      1024: { slidesPerView: 0.8, spaceBetween: 30 }
    },
    pagination: {
      el: mainEl.querySelector('.swiper-pagination'),
      clickable: true,
      type: 'bullets'
    },
    navigation: {
      nextEl: mainEl.querySelector('.swiper-button-next'),
      prevEl: mainEl.querySelector('.swiper-button-prev')
    },
    on: {
      init: function() {
        updateSlideVideos(this);
      },
      slideChangeTransitionEnd: function() {
        updateSlideVideos(this);
      }
    }
  });
}

function updateSlideVideos(swiperInstance) {
  swiperInstance.slides.forEach(function(slide) {
    var iframe = slide.querySelector('.youtube-iframe');
    if (iframe) {
      if (slide.classList.contains('swiper-slide-active')) {
        iframe.classList.remove('pointer-events-none');
      } else {
        iframe.classList.add('pointer-events-none');
        if (iframe.id && youtubePlayers[iframe.id]) {
          youtubePlayers[iframe.id].pauseVideo();
        }
      }
    }
  });
}

// Simplified accordion event binding using only the click event.
function setupAccordionDelegation() {
  var headers = document.querySelectorAll('.accordion-header');
  headers.forEach(function(header) {
    header.addEventListener('click', function(e) {
      e.preventDefault();
      accordionHeaderHandler(header);
    });
  });
}

// Toggle accordion state.
function accordionHeaderHandler(header) {
  console.log("Accordion header tapped:", header);
  // Close all accordion items.
  document.querySelectorAll(".accordion-item").forEach(function(item) {
    item.classList.remove("open");
  });
  
  // Open the tapped item's parent.
  var parentItem = header.parentElement;
  parentItem.classList.add("open");
}
